export default __webpack_public_path__ + "static/media/31t.27a9fd83.jpg";